module.exports = __webpack_public_path__ + "static/media/Vue-SDB_06-Bleu-Lagon-Bleu-ecume.6a437822.jpg";